import React from 'react';
import Page from './components/Page';
import PageTitle from './components/PageTitle';

function AttributionInfo() {
  return (
    <Page>
      <PageTitle title="Attributions" dataTestId="attribution-info"/>
      <a
        href="https://www.vecteezy.com/vector-art/7620250-shopping-bag-icon-set-of-4-ecommerce-design-element"
        target="_blank"
      >
        Shopping Bag Icon Vector by Grapict Studio
      </a>
    </Page>
  );
}

export default AttributionInfo;


